"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountsConfirmRevoke = void 0;
const modal_form_component_1 = require("../../components/modal.form/modal.form.component");
const index_1 = require("../../i18n/index");
const ACCOUNTS_REVOKE_SUCCESS = { key: index_1.T.ACCOUNTS_REVOKE_SUCCESS };
class AccountsConfirmRevoke extends modal_form_component_1.ModalFormComponent {
    constructor(ctrl, invite) {
        super({
            title: index_1.T.ACCOUNTS_REVOKE_TITLE,
            confirm: index_1.T.ACCOUNTS_REVOKE,
            success: ACCOUNTS_REVOKE_SUCCESS
        });
        this.ctrl = ctrl;
        this.invite = invite;
    }
    get nodes() {
        return (0, index_1.Translate)(index_1.T.ACCOUNTS_REVOKE_CONFIRM, this.invite.email);
    }
    submit() {
        return this.ctrl.removeUserInvite(this.invite);
    }
    failToChange() {
        this.ctrl.setLoading(this.invite.objectId, false);
    }
}
exports.AccountsConfirmRevoke = AccountsConfirmRevoke;
//# sourceMappingURL=accounts.confirm.revoke.js.map